
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCommandAutoTrack as ObiCommandAutoTrackElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-command-auto-track.js';
 
 
 

 
 export const ObiCommandAutoTrack = createComponent({
   react: React,
   tagName: 'obi-command-auto-track',
   elementClass: ObiCommandAutoTrackElement,
   events: {
     
   }
  });
 
 